import validateEmail from 'pruve/dist/validators/email';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '../Input/Input';

export default function One() {
	const { errors, control } = useFormContext();

	return (
		<div className='flex flex-col gap-4'>
			<h1 className='text-3xl my-4 md:mb-0 leading-tight font-light'>
				Let's get to know each other.
			</h1>
			<Controller
				name='name'
				control={control}
				rules={{
					required: 'Please enter your name',
					validate: {
						firstAndSurname: (value: string) => {
							const split = value.trim().split(' ');
							const valid =
								split.length > 1 && split[0].length > 0 && split[1].length > 0;
							if (valid === false)
								return 'Please enter your first name and surname';
							return true;
						},
					},
					minLength: {
						value: 4,
						message: 'Please enter your first name and surname',
					},
				}}
				render={props => {
					return (
						<Input
							type='text'
							onChange={props.onChange}
							nullable={false}
							error={errors?.name?.message}
							label="What's your name?"
							value={props.value}
							name='name'
							placeholder='Jane Smith'
							required
							autoComplete
						/>
					);
				}}
			/>
			<Controller
				name='email'
				control={control}
				rules={{
					required: 'Please enter a valid email address',
					validate: value => {
						return validateEmail(value) || 'Please enter a valid email address';
					},
				}}
				render={props => {
					return (
						<Input
							type='text'
							onChange={props.onChange}
							nullable={false}
							error={errors?.email?.message}
							label="What's your work email address?"
							value={props.value}
							name='email'
							placeholder='jane@example-company.com'
							tooltip='This is the email address you will use to log in to Stryve'
							required
							autoComplete
						/>
					);
				}}
			/>
		</div>
	);
}
